import { combineReducers } from "redux";
import { i18nReducer } from "react-redux-i18n";
import assessment from "./assessment";


const rootReducer = combineReducers({
    i18n: i18nReducer,
    assessment
});

export default rootReducer;